// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from "@components";

type Props = $Exact<{
  labels: Array<string>,
  modalTitle: string,
  modalContent: string,
  modalContentPlural: string,
  onDismissHandler: () => void,
  onSubmit: () => void,
  ...PropsFromLocalize,
}>;

export const NotificationDeleteModal = (props: Props) => (
  <Modal className="modal-small">
    <ModalHeader toggle={props.onDismissHandler} className="d-flex justify-content-between">
      {props.t(props.modalTitle)}
    </ModalHeader>
    <ModalBody className="d-flex justify-content-center align-items-center">
      <p className="normal-font-size">
        {props.labels.length > 1
          ? props.t(props.modalContentPlural)
          : props.t(props.modalContent, { name: props.labels[0] })}
      </p>
    </ModalBody>
    <ModalFooter className="d-flex justify-content-end">
      <Button color="secondary" onClick={props.onDismissHandler}>
        {props.t("CANCEL")}
      </Button>
      <Button materialIcon="delete_forever" onClick={props.onSubmit}>
        {props.t("DELETE")}
      </Button>
    </ModalFooter>
  </Modal>
);

export default localize()(NotificationDeleteModal);
